import ClearAllIcon from '@mui/icons-material/ClearAll';
import HistoryIcon from '@mui/icons-material/History';
import { Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FilterChip from 'components/FilterChip';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import UserRequests from '../components/UserRequests';

function UserRequestsPage() {
  const allDays = 10 * 365;
  const [resourceFilter, setResourceFilter] = useState<string>("");
  const [showYourResourcesFilter, setShowYourResourcesFilter] = useState<boolean>(true);

  const handleResourceFilterChange = (event: any) => {
    setResourceFilter(event.target.value);
  };

  const handleShowYourResourcesFilterChange = (event: any) => {
    console.log("handleShowAllResourcesFilterChange", event.target.checked)
    setShowYourResourcesFilter(event.target.checked);
  };

  return (
      <div className="content-surface">
        <div className="sticky-header">
          <Grid container alignItems="center">
            <Grid item xs={4}>
              <h3 className="page-title">Requests</h3>
            </Grid>
            <Grid container item xs={8} justifyContent="flex-end">

              <Stack direction="row" spacing={1} sx={{ m: 1, alignItems: 'center', justifyContent: 'center' }}>
                <FilterChip
                  label="All resources"
                  checked={showYourResourcesFilter}
                  onChange={setShowYourResourcesFilter}
                  icon={<ClearAllIcon />}
                />
              </Stack>

              {/* <FilterContextMenu showYourResourcesFilter={showYourResourcesFilter} onShowYourResourcesFilterChange={handleShowYourResourcesFilterChange} /> */}

              <TextField
                sx={{
                  m: 1,
                  minWidth: 250,
                  '& .MuiInputBase-root': {
                    height: 36.5,
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '8px 14px',
                  },
                  '& .MuiInputLabel-root': {
                    top: '-6px',
                  }
                }}
                label="Filter resources ..."
                variant="outlined"
                onChange={handleResourceFilterChange} />

              <Button
                sx={{ m: 1 }}
                component={Link}
                to={'/user/requests'}
                variant="contained"
                color="primary"
                startIcon={<HistoryIcon />}
              >
                Show request history
              </Button>
            </Grid>
          </Grid>
        </div>
        <UserRequests status='active' sinceDays={allDays} resourceFilter={resourceFilter} showAllResourcesFilter={!showYourResourcesFilter} />
      </div>
  );
}

export default UserRequestsPage;